<div class="c-card g--margin-t-15">
    <div class="c-card__body g--margin-b-30">

        <!-- Grupo Preferencias Aereo -->
        <ng-container *ngFor="let preferencia of preferencias">
            <div class="g--margin-t-30"
                *ngIf="preferencia.TipoProducto === ETipoProducto.Aereo  && preferencia.Visible && preferencia.Opciones !== null">
                <app-grupo-preferencia
                    #Grupo_Preferencia_Aereo
                    [Id]="preferencia.Id"
                    [TituloGrupo]="preferencia.ClaveTraduccion"
                    [ListaPreferencias] = "preferencia.Opciones"
                    [multiple]="preferencia.SeleccionMultiple"
                    [required]="preferencia.Obligatorio"
                    [listaOtros]="listaOtros"> 
                    <div *ngIf="preferencia.Id === 6">
                        <label class="numero-asiento" for="numero-asiento">{{"precliente.formulario.vuelo.numero-fila" |translate}}</label>
                        <input type="number" maxlength="2" min="0" max="99"  [(ngModel)]="numero">
                    </div>
                </app-grupo-preferencia>
            </div>
        </ng-container>
        
        <!-- Grupo Cadenas Aereas Preferentes -->
        <div class="g--margin-t-30">
            <div class="g--margin-t-30 c-section-altnative c-table c-table--scroll">
                <div class="c-section-alternative__header">
                    <b>{{"precliente.formulario.vuelo.cadenasaereaspreferentes" |translate}}</b>
                </div>
                <div class="c-section__body g--margin-t-40">
                <app-select-search-material
                    #Grupo_Preferencia_Aereo_Companias
                    [required]="false"
                    [buscador]="true"
                    [multiple]="true"
                    [opciones]="AereoLineas"
                    id="PaisExpedicion"
                    clase="form-control form-control-md"
                    claseIcono=""
                    label="{{'admin.comun.buscar' | translate }}"
                    placeholderBuscador="{{'admin.comun.buscar' | translate }}"
                    placeholderSelector="{{'admin.comun.buscar' | translate }}"
                >
                </app-select-search-material>
                </div>
            </div>
        </div>

        <!-- Grupo Observaciones Aereo -->
        <div class="g--margin-t-30">
            <div class="g--margin-t-30 c-section-altnative c-table c-table--scroll">
                <div class="c-section-alternative__header">
                    <app-observaciones
                    #Grupo_Preferencia_Aereo_Observaciones
                    [(textareaValue)] = "texto"
                    (textareaValueChange)="actualizarValorObservacion($event)"
                    ></app-observaciones>
                </div>
            </div>
        </div>
       
    </div>
</div>
